/**
 * Accounting export (ledger 200): the months a person can pick, and how a month
 * is written. Pure functions shared by both looks, so the list and the words
 * can never differ between them.
 *
 * A month travels as 'YYYY-MM' (what the server takes) and reads as
 * "October 2026". Built from the year and month numbers, never through
 * `new Date`, so no time zone can shift a month by a day.
 */
const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const monthWords = (value) => {
  const match = /^(\d{4})-(\d{2})/.exec(String(value || ''));
  if (!match) return String(value || '');
  const month = Number(match[2]);
  if (month < 1 || month > 12) return String(value);
  return `${MONTH_NAMES[month - 1]} ${match[1]}`;
};

/**
 * The last `count` months ending at `currentMonth` ('YYYY-MM', the server's
 * idea of today), newest first: [{ value: '2026-10', label: 'October 2026' }].
 */
export const monthChoices = (currentMonth, count = 24) => {
  const match = /^(\d{4})-(\d{2})/.exec(String(currentMonth || ''));
  if (!match) return [];
  let year = Number(match[1]);
  let month = Number(match[2]);
  const choices = [];
  for (let i = 0; i < count; i += 1) {
    const value = `${year}-${String(month).padStart(2, '0')}`;
    choices.push({ value, label: monthWords(value) });
    month -= 1;
    if (month === 0) {
      month = 12;
      year -= 1;
    }
  }
  return choices;
};
